/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { organizationUserSessionIssuersGetMigratePreflight } from "../funcs/organizationUserSessionIssuersGetMigratePreflight.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { OrganizationUserSessionIssuerMigratePreflight } from "../models/components/organizationusersessionissuermigratepreflight.js";
import {
  GetOrganizationUserSessionIssuerMigratePreflightRequest,
  GetOrganizationUserSessionIssuerMigratePreflightSecurity,
} from "../models/operations/getorganizationusersessionissuermigratepreflight.js";
import { unwrapAsync } from "../types/fp.js";
export type OrganizationUserSessionIssuerMigratePreflightQueryData =
  OrganizationUserSessionIssuerMigratePreflight;

export function prefetchOrganizationUserSessionIssuerMigratePreflight(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetOrganizationUserSessionIssuerMigratePreflightRequest,
  security?:
    | GetOrganizationUserSessionIssuerMigratePreflightSecurity
    | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildOrganizationUserSessionIssuerMigratePreflightQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildOrganizationUserSessionIssuerMigratePreflightQuery(
  client$: GramCore,
  request: GetOrganizationUserSessionIssuerMigratePreflightRequest,
  security?:
    | GetOrganizationUserSessionIssuerMigratePreflightSecurity
    | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<OrganizationUserSessionIssuerMigratePreflightQueryData>;
} {
  return {
    queryKey: queryKeyOrganizationUserSessionIssuerMigratePreflight({
      sourceId: request.sourceId,
      targetId: request.targetId,
      gramSession: request.gramSession,
    }),
    queryFn:
      async function organizationUserSessionIssuerMigratePreflightQueryFn(
        ctx,
      ): Promise<OrganizationUserSessionIssuerMigratePreflightQueryData> {
        const sig = combineSignals(
          ctx.signal,
          options?.signal,
          options?.fetchOptions?.signal,
        );
        const mergedOptions = {
          ...options?.fetchOptions,
          ...options,
          signal: sig,
        };

        return unwrapAsync(organizationUserSessionIssuersGetMigratePreflight(
          client$,
          request,
          security,
          mergedOptions,
        ));
      },
  };
}

export function queryKeyOrganizationUserSessionIssuerMigratePreflight(
  parameters: {
    sourceId: string;
    targetId: string;
    gramSession?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "organizationUserSessionIssuers",
    "getMigratePreflight",
    parameters,
  ];
}
